import { ApiService } from "./apiService";
import { LoginEmailDto, LoginMobileDto, PhoneDto } from "../types/dto";
import { ERoleType } from "../enum/ERoleType";

export const refreshToken = async () => {
  try {
    const userStr = localStorage.getItem('@user');
    const userJson = JSON.parse(userStr as string);
    const { apiToken, refreshToken, role } = await ApiService.put('auth/token/refresh', {
      refreshToken: userJson.refreshToken
    });
    userJson.apiToken = apiToken;
    userJson.refreshToken = refreshToken;
    userJson.role = role;
    localStorage.setItem('@user', JSON.stringify(userJson));
    return userJson;
  } catch (error) {
    throw error;
  }
}

export const sendLoginCode = async (payload: PhoneDto) => {
  try {
    return await ApiService.post(`auth/mobile/send-login-code`, payload);
  } catch (error) {
    throw error;
  }
}

export const loginMobile = async (payload: LoginMobileDto) => {
  try {
    return await ApiService.post(`auth/login/mobile`, payload);
  } catch (error) {
    throw error;
  }
}

export const logout = async () => {
  try {
    return await ApiService.post('auth/logout', {});
  } catch (error) {
    throw error;
  }
}
